import { Deserializable } from '../interfaces/deserialize';

export class PaymentDetailModel implements Deserializable {
  orderId?: string;
  product?: string;
  licences?: string;
  client?: string;
  amount?: string;
  merchantId?: string;
  sha1hash?: string;
  paymentMethod?: string;
  merchantResponseUrl?: string;
  payerRef?: string;
  taxPercent = 0;
  packs?: Array<{ amount: number; packId: any }>;
  haveToRenew?: { condition: boolean; purchasedPack: any };
  renovation?: boolean;
  premium?: boolean;

  deserialize(obj: any) {
    Object.assign(this, obj);
    return this;
  }
}
